module.exports = __webpack_public_path__ + "img/MicroscopesDissectingCompound.7e99dcc0.png";